import { AddPermissionModel } from './../../_models/role/RoleRequestModel';
import { GlobalService } from './../../_global/global.service';
import { Injectable } from '@angular/core';
import { Http } from '@angular/http';
import { Router, NavigationExtras } from '@angular/router';
import { BaseProvider } from '../BaseProvider';
import { RoleRequestModel, RoleResponseModel } from '../../_models/index';
import { Observable } from 'rxjs/Rx';
@Injectable()
export class RolesService extends BaseProvider {
    resource = 'roles';
    constructor(private router: Router, private http: Http, private _gs: GlobalService) {
        super(http);
    }
    getRoles(organisationId?: string) { // Fetch all roles given the token
        // var url = this.API_URL + this.resource;
        // return this.http.get(url, this.options).map(res => res);
        return this.makeGetCall(this.resource);
        //return this.makeGetCall(this.resource + '?partnerId=' + this._gs.currentUser.partner.id);
    }

    getPermissionsByGroup(organisationId?: string) { // Fetch permissions details grouped by group name
        // var url = this.API_URL + this.resource;
        // return this.http.get(url, this.options).map(res => res);
        // return this.makeGetCall(this.resource + "" + (organisationId == null ? "" : '?partnerId=' + organisationId));
        return this.makeGetCall('permissions?permissionView=grouped');
    }
    getRolesById(roleId) {
        return this.makeGetCall(this.resource + '/' + roleId);
    }
    getCdpRoles() {
        return this.makeGetCall('cdp/roles');
    }

    addRole(roleRequest: AddPermissionModel) {  // Add an role given the role details
        return this.makePostCall(this.resource, roleRequest);
    }
    editRole(role) {// TODO: to be removed from here
        const navigationExtras: NavigationExtras = {
            queryParams: {
                'id': role.id
            }
        };
        this.router.navigate(['/admin/role/edit'], navigationExtras);
    }
    deleteRole(roleId) { // Delete a role given the role id
        return this.makeDeleteCall(this.resource + '/' + roleId);
    }
    updateRole(roleId, roleRequest: AddPermissionModel) { // Update a role  given the updated role details
        return this.makePutCall(this.resource + '/' + roleId, roleRequest);
    }
}



// WEBPACK FOOTER //
// ./src/app/_services/roles/roles.service.ts